var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "modal-h1 mb-3" }, [
        _c("button", {
          staticClass: "btn btn-back",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              _vm.$emit("cancel")
            }
          }
        }),
        _vm._v(" "),
        _vm.emailTemplate.type_id === 1
          ? _c("span", [_vm._v("\n      Edit claim template\n    ")])
          : _vm.emailTemplate.type_id === 2
            ? _c("span", [
                _vm._v("\n      Edit acknowledgement template\n    ")
              ])
            : _vm.emailTemplate.type_id === 3
              ? _c("span", [_vm._v("\n      Edit settlement template\n    ")])
              : _vm._e()
      ]),
      _vm._v(" "),
      _vm.claimTypes.length && _vm.emailTemplate && _vm.variables
        ? _c("div", { staticClass: "l-bg-white" }, [
            _c("div", { staticClass: "row mb-2" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Claim type")]),
                    _vm._v(" "),
                    _c("key-multiselect", {
                      attrs: {
                        options: _vm.claimTypes,
                        "group-select": true,
                        "select-group-label": "Select All",
                        "deselect-group-label": "Deselect All",
                        multiple: true,
                        "clear-on-select": false,
                        "hide-selected": true,
                        "preserve-search": false,
                        label: "name",
                        "track-by": "id"
                      },
                      on: { input: _vm.updateClaimTypes },
                      scopedSlots: _vm._u([
                        {
                          key: "tag",
                          fn: function(props) {
                            return [
                              _c("span", { staticClass: "multiselect__tag" }, [
                                _c("span", [_vm._v(_vm._s(props.option.name))]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "multiselect__tag-icon",
                                  on: {
                                    click: function($event) {
                                      props.remove(props.option)
                                    }
                                  }
                                })
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.template.claim_type_ids,
                        callback: function($$v) {
                          _vm.$set(_vm.template, "claim_type_ids", $$v)
                        },
                        expression: "template.claim_type_ids"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.emailTemplate.type_id !== 1
                ? _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "div",
                        { staticClass: "select-wrap h-auto" },
                        [
                          _c("label", [_vm._v("Companies")]),
                          _vm._v(" "),
                          _vm.companies.length
                            ? _c("key-multiselect", {
                                attrs: {
                                  options: _vm.companies,
                                  multiple: true,
                                  "clear-on-select": false,
                                  "hide-selected": true,
                                  "preserve-search": false,
                                  label: "name",
                                  "track-by": "id"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "tag",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "multiselect__tag" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(props.option.name))
                                            ]),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "multiselect__tag-icon",
                                              on: {
                                                click: function($event) {
                                                  props.remove(props.option)
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.template.modelable_ids,
                                  callback: function($$v) {
                                    _vm.$set(_vm.template, "modelable_ids", $$v)
                                  },
                                  expression: "template.modelable_ids"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "modelable_ids" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Template name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.template.name,
                          expression: "template.name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.template.name },
                      on: {
                        keydown: function($event) {
                          _vm.clearError($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.template, "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "name" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Email subject")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.template.subject,
                        expression: "template.subject"
                      }
                    ],
                    ref: "subject",
                    staticClass: "form-control",
                    domProps: { value: _vm.template.subject },
                    on: {
                      keydown: function($event) {
                        _vm.clearError($event)
                      },
                      click: function($event) {
                        _vm.addingVariableOn = "subject"
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.template, "subject", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("div", { staticClass: "select-wrap h-auto" }, [
                    _c("label", [_vm._v("Email body")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.template.body,
                          expression: "template.body"
                        }
                      ],
                      ref: "ta",
                      staticClass: "select-wrap-textarea form-control",
                      attrs: { cols: "30", rows: "10" },
                      domProps: { value: _vm.template.body },
                      on: {
                        click: function($event) {
                          _vm.addingVariableOn = "ta"
                        },
                        keydown: function($event) {
                          _vm.clearError($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.template, "body", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "body" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-4" }, [
              _c(
                "div",
                { staticClass: "col" },
                _vm._l(_vm.variables, function(variable, key, index) {
                  return _c(
                    "span",
                    {
                      key: index,
                      staticClass:
                        "badge badge-primary mx-1 unselectable pointer",
                      on: {
                        click: function($event) {
                          _vm.insertVariable(variable)
                        }
                      }
                    },
                    [_vm._v(_vm._s(key))]
                  )
                })
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-delete float-left",
                    attrs: {
                      type: "button",
                      disabled: _vm.disableDeleteButton
                    },
                    on: { click: _vm.deleteClaimTemplate }
                  },
                  [
                    _vm._v("\n          Delete\n          "),
                    _vm.loadingDeleteButton
                      ? _c("div", { staticClass: "ld ld-ball ld-flip" })
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.closeModal()
                      }
                    }
                  },
                  [_vm._v("\n          Cancel\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ld-ext-right",
                    class: _vm.loadingButton ? "running" : "",
                    attrs: { type: "button", disabled: _vm.buttonDisabled },
                    on: { click: _vm.save }
                  },
                  [
                    _vm._v("\n          Save\n          "),
                    _c("div", { staticClass: "ld ld-ball ld-flip" })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" })
          ])
        : [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1db5c560", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db5c560","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/EditEmailTemplate.vue
// module id = null
// module chunks = 